/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function AIAgent({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 17" {...props}><path stroke="currentColor" strokeLinecap="round" strokeWidth={1.2} d="M9.938 10.969c0 .963-.868.984-1.938.984-1.07 0-1.938-.02-1.938-.984" /><path stroke="currentColor" strokeLinejoin="round" strokeWidth={1.2} d="M12.892 1.918a.094.094 0 0 1 .177 0c.17.485.275.784.447 1.04.152.228.342.428.56.592.248.185.54.306 1.016.502a.102.102 0 0 1 0 .189c-.476.196-.768.316-1.015.502a2.432 2.432 0 0 0-.561.591c-.172.257-.277.556-.447 1.04a.094.094 0 0 1-.177 0c-.17-.484-.276-.783-.448-1.04a2.433 2.433 0 0 0-.56-.591c-.248-.186-.54-.306-1.016-.502a.102.102 0 0 1 0-.189c.476-.196.768-.317 1.015-.502.22-.164.409-.364.561-.591.172-.257.277-.556.448-1.04Z" /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} d="M13.281 9.313v3.312a2 2 0 0 1-2 2H4.72a2 2 0 0 1-2-2V5.579c0-.768.623-1.391 1.391-1.391v0h4.016" /><path stroke="currentColor" strokeLinecap="round" strokeWidth={1.2} d="M2.314 11.344c-1.468 0-1.5-.867-1.5-1.938 0-1.07.032-1.937 1.5-1.937M15.155 9.406c0 1.07-.032 1.938-1.5 1.938M9.938 7.469v1M6.063 7.469v1" /></svg>;
}
;